import React, { useCallback, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import { useHistory, useParams } from 'react-router-dom';
import { DCR_API_BASE_SERVER_URL } from 'config';
import MessageModal from 'components/MessageModal';
import Tile from 'components/Tile/Tile';
import _ from 'lodash';
import { primaryColor } from '../../assets/jss/material-dashboard-pro-react';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
// @ts-ignore
import mixpanel from '../../mixpanel';
import {
  C_CREATE_CONVERSATION,
  C_GET_CONVERSATIONS_BY_VO,
  GET_CREDIT_SUBMISSION,
  Q_CREDIT_APP,
  Q_EQUIPMENT,
  QUERY_PORTAL_CONFIGURATION,
  M_BOOK_DEAL_LMS,
} from '../../components/SubmissionDetailsTabs_V2/queries/queries';
import {
  CHAT_V2_CONVERSATIONS,
  CHAT_V2_OPEN,
  CHAT_V2_RESET,
  SET_CHAT_TARGET_RECIPIENT,
  SET_VO,
} from '../../redux/types';
import { CHAT_V2_SET_CREDIT_SUBMISSION, CHAT_V2_SET_TARGET_CREDIT_SUBMISSION_ID } from 'redux/types';
import { Q_VO, QUERY_ACTIVE_OCA_TEMPLATE } from '../../queries/common';
import { portalConfigurationTypes } from '../Prequal/constants';
import { checkIfIndividualCreditApp } from '../../utils';
import {
  assignFieldsOCAConfigFromActiveTemplate,
  isItemHasRestrictionForRole,
} from '../../services/creditAppModalService';
import { getDefaultPortalConfigurationByType, rolesSettingsKeys } from '../../services/pcwService';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from '@mui/material';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { PageSkeleton } from './PageSkeleton';
import TransactionSummary from '../LenderPortal/CreditSubmissionDetails/TransactionSummaryCard';
import ApplicationSummary_V2 from '../LenderPortal/CreditSubmissionDetails/ApplicationSummary__V2';
import { CreditSubmissionsCard_V2 } from '../LenderPortal/CreditSubmissionDetails/CreditSubmissionsCard_V2';
import { SpecificTasks_V2 } from '../../components/SpecificTasks_V2';
import { LenderWaterfallResults } from '../VendorOpportunity/LenderWaterfallResults';
import { invoiceDetailAPIKey } from '../../components/SubmissionDetailsTabs_V2/configuration';
import { parseTableData } from '../../components/SubmissionDetailsTabs_V2/helpers';
import Paper from '@mui/material/Paper';
import { CardBackground } from '../../components/CardBackground/CardBackground';
import HealthCheckCard from '../VendorOpportunity/HealthCheckCard';
import FDRList from '../LenderPortal/CreditSubmissionDetails/FDRCard';
import ActivityList from '../LenderPortal/CreditSubmissionDetails/ActivityCard';
import ScoreCard from '../LenderPortal/CreditSubmissionDetails/ScoreCard';
import { ConversationsHistory } from '../LenderPortal/CreditSubmissionDetails/ConversationsHistory';
import { InvoiceEquipmentDetailsCard_V2 } from '../../components/InvoiceEquipmentDetailCard_V2/ui';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { CreditSubmissionTabs } from './types';
import { CreditSubmissionResponse, CreditSubmissionVariables } from '../../components/SubmissionDetailsTabs_V2/types';
import { Documents_V2 } from '../../components/Documents_V2';
import { SyndicationsList_V2 } from '../../components/SyndicationsList_V2/ui';
import { ProposalList_V2 } from '../../components/ProposalList_V2/ui';
import { DocumentContext } from 'contexts/DocumentContext';
import { PageTypes, TabsOption } from '../../global';
import { CreditApplicationDetailsFullView } from '../../modules/creditApplicationDetails';
import ApplicationSummaryModal from 'pages/LenderPortal/CreditSubmissionDetails/ApplicationSummaryModal';
import axios from 'axios';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { portalConfigurationsSelectors } from '../../redux/portalConfigurationReducer';
import { CreditSubmissionNotesCard } from '../../modules/creditSubmission/notes';
import { RenderWithCondition } from '../../components/shared/Conditional/RenderWithCondition';
import { generatePersonaFullName } from 'utils/formatters';
import { PageContainer } from '../../components/shared/Page/PageContainer';
import LMSResults from 'components/LMS';
import SendIcon from '@mui/icons-material/Send';
import { Label } from '@mui/icons-material';
import { ScoreCardV2 } from 'pages/VendorOpportunity/ScoreCardV2';

export const CreditSubmissionDetailsPageV2 = () => {
  const { push } = useHistory();
  const { id } = useParams<{ id: string }>();

  const [lastDocument, setLastDocument] = useState<any>();
  const dispatch = useDispatch();

  const relatedUsers = useSelector((state: any) => state.relatedUsers);
  const userProfile = useSelector((state: any) => state.userProfile);
  const account = useSelector((state: any) => state.account);
  const chat = useSelector((state: any) => state.chat);
  const refetchCS = useSelector((state: any) => state.cs.refetch);
  const vp = useSelector((state: any) => state.vp);
  const hideScoreCard = useSelector(portalConfigurationsSelectors.isPrescreenScorecardBuilderHidden);
  console.log(hideScoreCard);
  const allowSyndication = useSelector(state => portalConfigurationsSelectors.configData(state))?.[
    PortalConfigurationType.Portal
  ]?.jsonDefinition?.config?.allowSyndication;

  const allowLMS = useSelector(state => portalConfigurationsSelectors.configData(state))?.[
    PortalConfigurationType.Portal
  ]?.jsonDefinition?.config?.allowLMS;

  const classes = useStyles();
  const [openMessageModal, setOpenMessageModal] = useState<boolean>(false);
  const [submissionMessage] = useState<any>({});
  const [openLegacyDetailsModal, setOpenLegacyDetailsModal] = useState<boolean>(false);
  const [handleSubmitToLenderByProfileId, setHandleSubmitToLenderByProfileId] = useState<boolean>(false);

  const [appSummary, setAppSummary] = useState<any>();
  const [creating] = useState<boolean>(false);

  const [vendorProfile, setVendorProfile] = useState<any>(null);
  const [lmsCodeName, setLmsCodeName] = useState<string>('');
  const [location, setLocation] = useState<any>(null);
  const [CADMData, setCADMData] = useState<any>(null);
  const [ocaTemplateToUse, setOcaTemplateToUse] = useState<any>(null);
  const [isLegacyOCA, setIsLegacyOCA] = useState<boolean>(false);
  const [portalConfigurations, setPortalConfigurations] = useState<any>(null);
  const [CADMPortalConfiguration, setCADMPortalConfiguration] = useState<any>(null);
  const [isCreditReportsHiddenForUserRole, setIsCreditReportsHiddenForUserRole] = useState<boolean>(true);

  // This docs use only for 'handleOpenCreditReportDocument' handler
  const [documents, setDocuments] = useState<any>([]);

  const [showHealthCheck, setShowHealthCheck] = useState<boolean>(false);
  const [isHealthCheckHiddenForUserRole, setIsHealthCheckHiddenForUserRole] = useState<boolean>(true);

  const [triggerRefetchDocs, setTriggerRefetchDocs] = useState<any>('');

  const [allConfigurationsLoaded, setAllConfigurationsLoaded] = useState(false);
  const vo = useSelector((state: any) => state.vo);
  const reduxConversations = useSelector((state: any) => state.chatV2.conversations);

  const handleCloseModal = () => {
    setOpenMessageModal(false);
  };
  const handleClose = () => {
    setOpenLegacyDetailsModal(false);
  };
  const handleBookLMS = (creditSubmissionId: string | undefined | null) => {
    if (creditSubmissionId) {
      bookDealLMS({ variables: { input: { creditSubmissionId, lmsCodeName } } });
    }
  };
  const { data: creditSubmissionData, refetch } = useQuery<CreditSubmissionResponse, CreditSubmissionVariables>(
    GET_CREDIT_SUBMISSION,
    {
      fetchPolicy: 'no-cache',
      variables: { csId: id },
      context: { authRequired: true },
    }
  );

  const [
    getConversationsByVOId,
    { data: conversations, refetch: refetchConversations, loading: conversationsLoading },
  ] = useLazyQuery(C_GET_CONVERSATIONS_BY_VO);

  const [createConversation] = useMutation(C_CREATE_CONVERSATION, {
    context: { authRequired: true },
  });

  const [bookDealLMS] = useMutation(M_BOOK_DEAL_LMS, {
    context: { authRequired: true },
  });

  const [
    getPortalConfigurations,
    { data: portalConfigurationData, loading: portalConfigurationDataLoading, called: portalConfigurationDataCalled },
  ] = useLazyQuery(QUERY_PORTAL_CONFIGURATION, {
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
  });

  const [
    getCADMPortalConfigurations,
    {
      data: CADMPortalConfigurationData,
      loading: CADMPortalConfigurationDataLoading,
      called: CADMPortalConfigurationDataCalled,
    },
  ] = useLazyQuery(QUERY_PORTAL_CONFIGURATION, {
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (
      portalConfigurationDataCalled &&
      CADMPortalConfigurationDataCalled &&
      !(portalConfigurationDataLoading || CADMPortalConfigurationDataLoading)
    ) {
      setAllConfigurationsLoaded(true);
    }
  }, [
    portalConfigurationDataCalled,
    CADMPortalConfigurationDataCalled,
    portalConfigurationDataLoading,
    CADMPortalConfigurationDataLoading,
  ]);

  const [getActiveOcaTemplate] = useLazyQuery(QUERY_ACTIVE_OCA_TEMPLATE, {
    fetchPolicy: 'no-cache',
    onCompleted(data) {
      setOcaTemplateToUse(_.first(data.getOcaTemplatesByVendorProfile));
    },
  });

  const [getCreditAppData, { data: creditAppData, loading: creditAppLoading }] = useLazyQuery(Q_CREDIT_APP, {
    fetchPolicy: 'no-cache',
  });

  const [getEquipmentData, { data: equipmentData }] = useLazyQuery(Q_EQUIPMENT);

  const [getVoData, { data: voData }] = useLazyQuery(Q_VO, { fetchPolicy: 'no-cache' });

  const handleOpenCreditReportDocument = (_: any, cbr: any) => {
    const reportDoc = documents.find((d: any) => d.key === cbr.humanReadableReportDocumentId);
    if (reportDoc) {
      window.open(reportDoc.link, '_newtab');
    }
  };

  const handleCreateConversation = useCallback(() => {
    console.log('CONVERSATIONS ADD CONVERSATION CLICKED EVENT FIRED');
    // @ts-ignore
    mixpanel.track('CONVERSATIONS: ADD CONVERSATION CLICKED');

    dispatch({ type: CHAT_V2_RESET });
    dispatch({ type: CHAT_V2_OPEN, payload: true });
  }, [creditSubmissionData, vo, createConversation, userProfile, dispatch, conversations]);

  useEffect(() => {
    if (vo && vo.vendorOpportunityId) {
      getConversationsByVOId({
        variables: {
          vendorOpportunityId: vo.vendorOpportunityId,
        },
      });
    }
  }, [vo, getConversationsByVOId]);

  useEffect(() => {
    if (conversations && conversations.getConversationsForVendorOpportunity) {
      dispatch({
        type: CHAT_V2_CONVERSATIONS,
        payload: conversations.getConversationsForVendorOpportunity,
      });
    }
  }, [conversations, dispatch]);

  useEffect(() => {
    if (creditSubmissionData) refetch();
  }, [refetchCS]);

  useEffect(() => {
    dispatch({ type: CHAT_V2_RESET });
    dispatch({ type: CHAT_V2_CONVERSATIONS, payload: [] });
  }, [dispatch]);

  useEffect(() => {
    if (creditSubmissionData && creditSubmissionData.creditSubmission) {
      dispatch({
        type: CHAT_V2_SET_CREDIT_SUBMISSION,
        payload: creditSubmissionData.creditSubmission,
      });
    }
  }, [dispatch, creditSubmissionData]);

  useEffect(() => {
    if (
      conversationsLoading ||
      !vo ||
      !vo.vendorOpportunityId ||
      !creditSubmissionData ||
      !creditSubmissionData.creditSubmission ||
      !userProfile ||
      !conversations
    ) {
      return;
    }

    if (conversations.getConversationsForVendorOpportunity?.length) return;

    const input = {
      vendorOpportunityId: vo.vendorOpportunityId,
      topic: 'RE: ' + creditSubmissionData.creditSubmission.applicant,
      initialParticipant: {
        participantUserProfileId: userProfile.id,
        identity: `${userProfile.fullName}`,
        phoneNumber: null,
        email: userProfile.email,
        notifyByEmail: Boolean(userProfile.email),
        notifyBySMS: false,
        notifyByWhatsapp: false,
      },
    };

    createConversation({ variables: { input } });
  }, [conversationsLoading, vo, creditSubmissionData, userProfile, conversations, createConversation]);

  useEffect(() => {
    if (creditSubmissionData) {
      const cs = creditSubmissionData.creditSubmission;

      const voId = _.get(cs, 'voId', '');
      const creditSubId = _.get(cs, 'creditSubId', '');
      const contactUserProfileId = _.get(cs, 'contactUserProfileId', null);

      const targetRecipient = _.find(relatedUsers, {
        id: contactUserProfileId,
      });

      if (targetRecipient) {
        dispatch({
          type: SET_CHAT_TARGET_RECIPIENT,
          payload: {
            targetRecipient: [
              {
                id: targetRecipient.id,
                accountId: targetRecipient.account.id,
                mughshot: targetRecipient.mugshot,
                vendorContactRole: targetRecipient.vendorContactRole,
                email: targetRecipient.email,
                firstName: targetRecipient.firstName,
                lastName: targetRecipient.lastName,
                fullName: targetRecipient.fullName,
                mobilePhoneNumber: targetRecipient.mobilePhoneNumber,
                company: targetRecipient.account.name,
              },
            ],
          },
        });
      }

      dispatch({
        type: CHAT_V2_SET_TARGET_CREDIT_SUBMISSION_ID,
        payload: creditSubId,
      });

      getVoData({ variables: { voId } });
      getCreditAppData({ variables: { VOId: voId } });
      getEquipmentData({ variables: { VOId: voId } });
    }
  }, [creditSubmissionData, relatedUsers, dispatch]);

  const refetchDocs = () => {
    setTriggerRefetchDocs(new Date().getTime());
  };

  useEffect(() => {
    setLmsCodeName(_.get(account, 'lms[0]', ''));
  }, [account]);

  useEffect(() => {
    if (_.every([equipmentData, vo?.vendorOpportunityId, CADMPortalConfiguration, vendorProfile])) {
      setCADMData({
        equipmentData,
        vo,
        CADMPortalConfiguration,
        vendorProfile: _.get(vendorProfile, 'vendorProfile'),
      });
    }
  }, [equipmentData, vo, CADMPortalConfiguration, vendorProfile, CADMPortalConfiguration]);

  useEffect(() => {
    if (_.get(vendorProfile, 'vendorProfile.id')) {
      getPortalConfigurations({
        variables: {
          vendorProfileId: _.get(vendorProfile, 'vendorProfile.id'),
          types: [portalConfigurationTypes.documents],
        },
      });
    }

    if (_.get(vendorProfile, 'vendorProfile.ofacRedFlagComplianceAccess', false)) {
      setShowHealthCheck(true);
    }
  }, [vendorProfile]);

  useEffect(() => {
    if (_.isEmpty(creditAppData?.creditApplication)) {
      return;
    }

    const { creditApplication } = creditAppData;

    const currentCreditAppOcaTemplate = creditApplication.ocaTemplate;
    let vpIdToGetCADMPortalConfigurations;
    if (currentCreditAppOcaTemplate) {
      // Credit app could be submitted from both the lender's and dealer's templates
      vpIdToGetCADMPortalConfigurations = currentCreditAppOcaTemplate.vendorProfileId;
      setOcaTemplateToUse(currentCreditAppOcaTemplate);
      setIsLegacyOCA(false);
    } else {
      // For OCAv3, currentCreditAppOcaTemplate will be empty, so we want to use Dealer's current active OCA template
      vpIdToGetCADMPortalConfigurations = vo.vendorProfileId;
      getActiveOcaTemplate({
        variables: {
          vendorProfileId: vo.vendorProfileId,
          isActive: true,
        },
      });
      setIsLegacyOCA(true);
    }

    getCADMPortalConfigurations({
      variables: {
        vendorProfileId: vpIdToGetCADMPortalConfigurations,
        types: [portalConfigurationTypes.CADMIndividual, portalConfigurationTypes.CADMCommercial],
      },
    });

    setLocation(_.get(creditAppData, 'creditApplication.location'));
  }, [creditAppData]);

  useEffect(() => {
    if (!CADMPortalConfigurationData || !creditAppData || !ocaTemplateToUse) return;

    const applicationType = _.get(creditAppData, 'creditApplication.applicationType');
    const portalConfigurations = _.get(CADMPortalConfigurationData, 'portalConfigurations') || [];
    const isIndividualCreditApp = checkIfIndividualCreditApp(applicationType);
    const CADMConfigurationTypeToUse = isIndividualCreditApp
      ? portalConfigurationTypes.CADMIndividual
      : portalConfigurationTypes.CADMCommercial;
    const CADMConfigurationToUse = _.find(portalConfigurations, { type: CADMConfigurationTypeToUse });
    if (_.some(CADMConfigurationToUse)) {
      assignFieldsOCAConfigFromActiveTemplate(CADMConfigurationToUse.jsonDefinition, ocaTemplateToUse.jsonDefinition);
    }
    setCADMPortalConfiguration(CADMConfigurationToUse);
  }, [CADMPortalConfigurationData, creditAppData, ocaTemplateToUse]);

  useEffect(() => {
    if (!portalConfigurationData) return;

    const portalConfigurations = _.get(portalConfigurationData, 'portalConfigurations') || [];

    const portalConfigurationsToSetByDefault = [portalConfigurationTypes.documents];
    _.forEach(portalConfigurationsToSetByDefault, portalConfigurationType => {
      if (!_.find(portalConfigurations, { type: portalConfigurationType })) {
        portalConfigurations.push(
          getDefaultPortalConfigurationByType(portalConfigurationType, account.vendorProfileId)
        );
      }
    });

    setPortalConfigurations(portalConfigurations);

    const isCreditReportsHiddenForUserRole = isItemHasRestrictionForRole(
      _.get(portalConfigurations, `${portalConfigurationTypes.creditReports}.jsonDefinition`),
      rolesSettingsKeys.hidden,
      userProfile.vendorContactRole
    );

    setIsCreditReportsHiddenForUserRole(isCreditReportsHiddenForUserRole);

    const isHealthCheckHiddenForUserRole = isItemHasRestrictionForRole(
      _.get(portalConfigurations, `${portalConfigurationTypes.healthCheck}.jsonDefinition`),
      rolesSettingsKeys.hidden,
      userProfile.vendorContactRole
    );
    setIsHealthCheckHiddenForUserRole(isHealthCheckHiddenForUserRole);
  }, [portalConfigurationData]);

  useEffect(() => {
    if (!voData?.vendorOpportunity) return;

    dispatch({ type: SET_VO, payload: voData.vendorOpportunity });
  }, [voData]);

  const handleLegacyCreditAppRequest = async () => {
    setOpenLegacyDetailsModal(true);

    return axios
      .post(
        `${DCR_API_BASE_SERVER_URL}/create-lender-pdf?transaction_id=${creditSubmissionData?.creditSubmission?.pgTransactionId}`,
        {
          dealerName: creditSubmissionData?.creditSubmission?.dealer,
          userProfile,
          vendorProfile,
          download: false,
        },
        {
          responseType: 'json',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'text/html',
          },
        }
      )
      .then(response => {
        setAppSummary(response.data);
      })
      .catch(error => console.log(error));
  };

  const callbackSubmissionFinished = (dynamicsCreditSubmissionId: any) => {
    console.log(`Finished submission with ID ${dynamicsCreditSubmissionId}`);
    //Send mutation to update Lender Waterfall
    setHandleSubmitToLenderByProfileId(false);
  };

  const [pageContentViewType, setPageContentViewType] = useState<'full' | 'details'>('full');

  const invoiceDetailTableBody = creditSubmissionData?.creditSubmission
    ? invoiceDetailAPIKey.map(key => parseTableData(creditSubmissionData.creditSubmission, key))
    : [];
  invoiceDetailTableBody.forEach(item => (item[0] = <b>{item[0]}</b>));

  const tabs: TabsOption<CreditSubmissionTabs>[] = [
    {
      label: 'General',
      value: CreditSubmissionTabs.General,
      isVisible: true,
      component: (
        <Box className={classes.generalContainer}>
          <Box className={classes.row}>
            <ApplicationSummary_V2
              goToCADView={() => {
                setPageContentViewType('details');
              }}
              cs={creditSubmissionData?.creditSubmission}
              vo={vo}
              lendersVendorProfile={vp}
              creditApplication={creditAppData?.creditApplication}
              isCreditReportsHiddenForUserRole={isCreditReportsHiddenForUserRole}
              refetchCreditApp={() => {
                getCreditAppData({
                  variables: {
                    VOId: _.get(creditSubmissionData, 'creditSubmission.voId', null),
                  },
                });
                refetchDocs();
              }}
              handleOpenCreditReportDocument={handleOpenCreditReportDocument}
              setVendorProfile={setVendorProfile}
              location={location}
            />

            <InvoiceEquipmentDetailsCard_V2
              invoiceDetailTableBody={invoiceDetailTableBody}
              cs={creditSubmissionData?.creditSubmission!}
            />
          </Box>

          {creditSubmissionData?.creditSubmission?.transactionSummary && (
            <Grid container direction="row" spacing={2}>
              <Grid item lg={6} xl={6} md={6} sm={12} xs={12}>
                <TransactionSummary cs={creditSubmissionData?.creditSubmission} />
              </Grid>
            </Grid>
          )}

          <>
            {showHealthCheck &&
              creditAppData?.creditApplication?.creditApplicationOwner?.length > 0 &&
              !isHealthCheckHiddenForUserRole && (
                <Tile title="Health Check" useCollapsing>
                  <HealthCheckCard
                    owners={creditAppData.creditApplication.creditApplicationOwner}
                    refetchCreditApp={() =>
                      getCreditAppData({
                        variables: {
                          VOId: _.get(creditSubmissionData, 'creditSubmission.voId', null),
                        },
                      })
                    }
                    vo={vo}
                    vp={vendorProfile}
                    creditApp={creditAppData.creditApplication}
                    full={true}
                  />
                </Tile>
              )}

            <CreditSubmissionsCard_V2 cs={creditSubmissionData?.creditSubmission} />

            <MessageModal
              link={null}
              isOpen={openMessageModal}
              handleCloseModal={handleCloseModal}
              title={submissionMessage.title}
              message={submissionMessage.message}
            />
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {!hideScoreCard && creditAppData?.creditApplication ? (
                  <ScoreCardV2
                    vo={vo}
                    refetchVO={() => {}}
                    equipmentData={creditAppData?.creditApplication}
                    cs={creditSubmissionData?.creditSubmission}
                    refetchCreditSubmission={refetch}
                    refetchEquipment={() => {}}
                    equipmentLoading={false}
                    creditApplication={creditAppData?.creditApplication}
                    vp={vendorProfile}
                    userProfile={userProfile}
                    account={account}
                    refetchCreditApp={() => {
                      getCreditAppData({
                        variables: {
                          VOId: _.get(creditSubmissionData, 'creditSubmission.voId', null),
                        },
                      });
                    }}
                    portalConfigurationDataLoading={
                      portalConfigurationDataLoading || CADMPortalConfigurationDataLoading
                    }
                    creditAppOwners={creditAppData?.creditApplication?.creditApplicationOwner}
                  />
                ) : null}
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item lg={12} xl={8} md={12} sm={12} xs={12}></Grid>
              {chat.enabled && (
                <Grid item lg={12} xl={8} md={12} sm={12} xs={12}>
                  <ConversationsHistory
                    loading={conversationsLoading || creating}
                    conversations={reduxConversations}
                    onConversationAdd={handleCreateConversation}
                  />
                </Grid>
              )}

              {account.dynamicsAccountId === '5e7f2efe-5c02-eb11-8125-065d4ad39109' && (
                <Grid item lg={12} xl={8} md={12} sm={12} xs={12}>
                  <ActivityList
                    vo={vo}
                    tileTitle=""
                    account={account}
                    userProfile={null}
                    creditSubId={creditSubmissionData?.creditSubmission?.creditSubId}
                  />
                </Grid>
              )}

              {account.dynamicsAccountId === '5e7f2efe-5c02-eb11-8125-065d4ad39109' && (
                <Grid item lg={12} xl={8} md={12} sm={12} xs={12}>
                  <FDRList
                    vo={vo}
                    cs={creditSubmissionData?.creditSubmission}
                    tileTitle=""
                    account={account}
                    userProfile={null}
                    dynamicsTransactionId={creditSubmissionData?.creditSubmission?.transactionId}
                  />
                </Grid>
              )}

              <RenderWithCondition condition={!!creditSubmissionData?.creditSubmission?.creditSubId}>
                <Grid item xs={12}>
                  <CreditSubmissionNotesCard
                    userName={generatePersonaFullName(userProfile)}
                    csId={creditSubmissionData?.creditSubmission?.creditSubmissionId!}
                    dynamicCSId={creditSubmissionData?.creditSubmission?.creditSubId!}
                  />
                </Grid>
              </RenderWithCondition>
            </Grid>
          </>
        </Box>
      ),
      urlAnchor: '#general',
    },
    {
      label: 'Tasks',
      value: CreditSubmissionTabs.Tasks,
      isVisible: true,
      component: (
        <SpecificTasks_V2
          vo={vo}
          cs={creditSubmissionData?.creditSubmission!}
          account={account}
          userProfile={userProfile}
          refetchDocs={refetchDocs}
        />
      ),
      urlAnchor: '#tasks',
    },
    {
      label: 'Documents',
      value: CreditSubmissionTabs.Documents,
      isVisible: true,
      component: allConfigurationsLoaded ? (
        <Documents_V2
          cs={creditSubmissionData?.creditSubmission}
          CADMData={CADMData}
          handleSetDocuments={setDocuments}
          triggerRefetchDocs={triggerRefetchDocs}
          portalConfigurations={portalConfigurations}
          isConfigurationLoaded={allConfigurationsLoaded}
        />
      ) : (
        <CircularProgress />
      ),
      urlAnchor: '#documents',
    },
    {
      label: 'LMS File',
      value: CreditSubmissionTabs.LMS,
      isVisible: !!allowLMS && !!_.get(creditSubmissionData, 'creditSubmission.lmsBookedData'),
      component: (
        <>
          {!!allowLMS && !!_.get(creditSubmissionData, 'creditSubmission.lmsBookedData') && (
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <LMSResults data={_.get(creditSubmissionData, 'creditSubmission.lmsBookedData')} />
              </Grid>
            </Grid>
          )}
        </>
      ),
      urlAnchor: '#lms',
    },
    {
      label: 'Syndications',
      value: CreditSubmissionTabs.Syndications,
      isVisible: allowSyndication,
      component: (
        <Grid container spacing={1}>
          {vo.vendorOpportunityId && allowSyndication && (
            <Grid item xs={12}>
              <LenderWaterfallResults
                creditSubmissions={creditSubmissionData?.creditSubmission}
                accountId={account.id}
                vendorOpportunityId={vo.vendorOpportunityId}
                handleSubmitToLenderByProfileId={setHandleSubmitToLenderByProfileId}
                lenderProfiles={vp.lenderProfiles?.filter((profile: any) => profile.id)}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <SyndicationsList_V2
              cs={creditSubmissionData?.creditSubmission}
              equipmentData={invoiceDetailTableBody}
              callbackSubmissionFinished={callbackSubmissionFinished}
              handleSubmitToLenderByProfileId={handleSubmitToLenderByProfileId}
              portalConfiguration={portalConfigurations}
            />
          </Grid>
        </Grid>
      ),
      urlAnchor: '#syndications',
    },
    /*    {
      label: 'Scorecard',
      value: CreditSubmissionTabs.Scorecard,
      isVisible: hideScoreCard,
      component: <ScoreCard cs={creditSubmissionData?.creditSubmission} />,
      urlAnchor: '#scorecard',
    }, */
    {
      label: 'Proposals',
      value: CreditSubmissionTabs.Proposals,
      isVisible: true,
      component: (
        <ProposalList_V2
          cs={creditSubmissionData?.creditSubmission!}
          voId={creditSubmissionData?.creditSubmission?.voId}
          applicant={creditSubmissionData?.creditSubmission?.applicant}
          pageType={PageTypes.CreditSubmission}
          showOnlyLenderPrograms={
            account.dynamicsAccountId === '10106e7c-d667-eb11-812d-066ef92796c9' ||
            account.dynamicsAccountId === 'f970df4b-81f6-ed11-816e-066ef92796c9' ||
            account.dynamicsAccountId === 'f8c9b561-d4fd-e011-9cc1-005056a20000'
          }
        />
      ),
      urlAnchor: '#proposals',
    },
  ];

  const render = {
    full: (
      <DocumentContext.Provider
        value={{
          lastDoc: lastDocument,
          documents: [],
          setLastDocument,
        }}
      >
        <Box className={classes.pageContainer}>
          <Paper className={classes.head} elevation={0}>
            <Box className={classes.headContent}>
              <Typography variant="h5">
                Submission Details: {creditSubmissionData?.creditSubmission?.applicant}
              </Typography>

              <Breadcrumbs
                currentValue="Detail"
                config={[
                  { label: 'List View', value: 'list', onClick: () => push('/cs') },
                  { label: 'Detail', value: 'Detail', onClick: () => {} },
                ]}
              />
            </Box>
            {!!allowLMS && (
              <Grid container spacing={2}>
                <Grid xs={12} item>
                  <Grid container spacing={2} justifyContent="flex-end" alignItems="flex-end">
                    <Grid xs={3} item className={classes.lmsContainer}>
                      <FormControl>
                        <FormLabel id="demo-controlled-radio-buttons-group">LMS Available:</FormLabel>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={lmsCodeName}
                          radioGroup="lmsCodeName"
                          onChange={val => {
                            setLmsCodeName(val.target.value);
                          }}
                          row
                        >
                          {_.get(account, 'lms', []).map((lms: any) => {
                            return (
                              <FormControlLabel
                                key={lms}
                                value={lms}
                                control={<Radio />}
                                label={lms
                                  .replace(/_/g, ' ')
                                  .toLowerCase()
                                  .replace(/\b(\w)/g, (char: string) => char.toUpperCase())}
                              />
                            );
                          })}
                        </RadioGroup>
                      </FormControl>
                      <Button
                        fullWidth={true}
                        variant="outlined"
                        disabled={_.get(creditSubmissionData, 'creditSubmission.lmsBookedData')}
                        onClick={() => {
                          handleBookLMS(creditSubmissionData?.creditSubmission?.creditSubmissionId);
                        }}
                      >
                        Send <SendIcon />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Paper>

          <Box className={classes.container}>
            <TabsContainer<CreditSubmissionTabs> tabs={tabs} TabsLabelWrapper={CardBackground} isSyncWithAnchor />
          </Box>
        </Box>
      </DocumentContext.Provider>
    ),
    details: (
      <CreditApplicationDetailsFullView
        backToCommonView={() => {
          setPageContentViewType('full');
        }}
        creditApplicationState={{
          isLegacyOCA,
          vo: CADMData?.vo,
          account: account,
          isEditingDisabled: true,
          applicant: creditSubmissionData?.creditSubmission?.applicant!,
          pageType: PageTypes.CreditSubmission,
          vendorProfile: CADMData?.vendorProfile,
          equipmentData: CADMData?.equipmentData,
          creditAppModalConfig: CADMData?.CADMPortalConfiguration?.jsonDefinition,
          handleLegacyCreditAppRequest,
        }}
      />
    ),
  };

  return (
    <PageContainer>
      <PageSkeleton show={!creditSubmissionData?.creditSubmission} />
      {creditSubmissionData?.creditSubmission && render[pageContentViewType]}
      <Modal
        open={openLegacyDetailsModal}
        onClose={handleClose}
        aria-labelledby="Credit Application"
        aria-describedby="Summary"
      >
        <ApplicationSummaryModal {...appSummary} />
      </Modal>
    </PageContainer>
  );
};

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  defaultTextWeight: {
    fontWeight: 300,
  },
  lmsContainer: {
    padding: '5px',
    border: '1px solid #e0e0e0',
    borderRadius: '5px',
    margin: '5px 0',
  },
  a: {
    color: primaryColor[0],
    '&:hover': {
      color: primaryColor[1],
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  pageContainer: {
    minHeight: '100vh',
    gap: '0.3rem',
    display: 'flex',
    flexDirection: 'column',
  },
  head: {
    padding: '1.5rem 1.5rem 0.5rem 1.5rem',
  },
  headContent: {
    gap: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    gap: '0.3rem',
    display: 'flex',
    flexDirection: 'column',
  },
  generalContainer: {
    gap: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    gap: '0.5rem',

    '& > *': {
      flexBasis: '50%',
    },
  },
  selectStyles: {
    margin: '8px 0',
    height: 40,

    '& .MuiOutlinedInput-input': {
      padding: '8px 24px',
    },
    '& fieldset legend span': {
      fontSize: 12,
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
      textTransform: 'none',
      fontWeight: 'normal',
      display: '-webkit-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '-webkit-line-clamp': 1,
      '-webkit-box-orient': 'vertical',
    },
  },
}));
